import React from 'react';
import HistoryTransactionContainer from '@src/containers/HistoryTransaction';

const HistoryTransaction = () => <HistoryTransactionContainer />;

export default HistoryTransaction;
